<template>
  <a :href="content.url" target="_blank" v-if="content.type === 'image'">
    <img :src="content.url" class="d-block mw-100 carousel-img">
  </a>
  <div v-else>
    <video :src="content.url" class="d-block mw-100 carousel-img" v-else-if="content.type === 'video'"></video>
    <iframe :src="content.url" class="d-block mw-100 carousel-img" v-else-if="content.type === 'iframe'" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
  </div>

</template>

<script>
export default {
  props: {
    content: ''
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CarouselContent.vue